// Dependencies
import React from 'react';
import _ from 'lodash';
import Api from '../api'
import { Helpers, Defaults, Config } from '../utils';

// Types
import { Containers, Types } from '../types';
import Megamenu from './Megamenu';

const initialState: any = {
    loading: true,
    errors: [],
    items: [],
    ...Defaults
}

const App = () => {
    
    // NOTE: Handles data fetching only (both from internal and external sources)
    const [store, updateStore] = React.useState<any>(initialState);

    const setState = (key: string, value: any) => {
        if (!(key in initialState)) {
            throw Error(`Key ${key} is not valid state.`);
        }
        updateStore((prevStore: any) => ({ ...prevStore, [key]: value instanceof Function ? value(prevStore[key]) : value, }))
    }

    const loadInternalData = async () => {
        const data = {
            id: Config.REACT_APP_MENU_ID,
            ...Config.REACT_APP_DATA
        }
        updateStore((prevState: any) => _.merge(Defaults, prevState, data));
    }

    const loadExternalData = async () => {
        setState('loading', true);        
        
        // TODO: Check if productID is provied and is valid number before request
        // Config.REACT_APP_PRODUCT_ID 
        if ( ! Config.REACT_APP_MENU_ID ) {
            setState('errors', (prevState: any) => prevState.push({type: 'critical', code: 'invalid_menu_id', message: 'Unable to load menu, no menuID has been provided.'}))
            return;
        }
        
        const externalData = await Api.getMegamenuData(Config.REACT_APP_MENU_ID);
        const { data } = externalData;

        // TODO: Validate response/handle errors
        updateStore((prevState: any) => _.merge(Defaults, prevState, data))

        setState('loading', false);
    }
 
    React.useEffect(() => {
        loadInternalData();
        // loadExternalData();
        return () => {}
    }, []);

    // TODO: This will be actually the main App component handling data fetching
    return <Megamenu {...store} />
    
}

export default App;
